import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './VideoCard.scss';

class VideoCard extends Component {
  render() {
    return (
      <div className="video-card">
        <iframe
          src={`${this.props.source}?fs=0`}
          title={this.props.title}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </div>
    );
  }
}

VideoCard.propTypes = {
  source: PropTypes.string,
  title: PropTypes.string
};

export default VideoCard;
